import { IconButton, Popover, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import React, { MouseEvent } from 'react'
import i18next from 'i18next'
import { useCustomTranslation } from '../../Hooks/useCustomTranslation'
import { languages } from '../../Configuration/languages'

export interface LanguageIcon {
  shortName: string
  icon: string
  translationKey: string
}

const useStyles = makeStyles()(theme => ({
  languageIcon: {
    width: 'auto',
    height: 24,
  },
  buttonIcon: {
    border: '1px solid',
    borderColor: theme.palette.primary.contrastText,
  },
  menu: {
    padding: 0,
  },
  withoutIcon: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1),
    },
    color: theme.palette.text.header,
    textAlign: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}))

interface LanguageSelectProps {
  withIcons?: boolean
}

const LanguageSelect: React.VFC<LanguageSelectProps> = ({ withIcons = true }) => {
  const [anchorEl, setAnchorEl] = React.useState<Element | undefined>(undefined)
  const [open, setOpen] = React.useState(false)
  const { classes, cx } = useStyles()
  const { t } = useCustomTranslation()

  const onClick = (event: MouseEvent): void => {
    setAnchorEl(event.currentTarget)
    setOpen(true)
  }
  const setLanguage = (lang: string): void => {
    setOpen(false)
    i18next.changeLanguage(lang)
  }
  return (
    <>
      {withIcons ? (
        <IconButton onClick={onClick} data-qa={'button-header-language-menu'}>
          <img
            src={languages.find(language => language.shortName === i18next.language)?.icon}
            alt={i18next.language?.toUpperCase()}
            className={cx(classes.languageIcon, classes.buttonIcon)}
          />
        </IconButton>
      ) : (
        <div onClick={onClick} data-qa={'button-header-language-menu'} className={cx(classes.languageIcon, classes.withoutIcon)}>
          {i18next.language?.toLocaleUpperCase()}
        </div>
      )}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{
          paper: classes.menu,
        }}
      >
        <List component="nav" aria-label="Languages">
          {languages.map(language => (
            <ListItem
              button
              key={language.shortName}
              onClick={() => setLanguage(language.shortName)}
              data-qa={'button-header-language-' + language.shortName}
            >
              {withIcons && (
                <ListItemIcon>
                  <img src={language.icon} alt={t('common.languages.' + language.translationKey)} className={classes.languageIcon} />
                </ListItemIcon>
              )}
              <ListItemText primary={t('common.languages.' + language.translationKey)} />
            </ListItem>
          ))}
        </List>
      </Popover>
    </>
  )
}

export default LanguageSelect
